import React, { Component } from 'react'
import { Button, Typography, Box } from '@mui/material'

/**
 * Isolates render crashes to one section so the rest of the shop stays usable.
 * Global ErrorHandler in App remains as last resort.
 */
class SectionErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, errorMessage: '' }
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      errorMessage: error?.message || 'Unknown error',
    }
  }

  componentDidCatch(error, errorInfo) {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.error(`[SectionErrorBoundary:${this.props.section || 'app'}]`, error, errorInfo)
    }
  }

  handleRetry = () => {
    this.setState({ hasError: false, errorMessage: '' })
  }

  render() {
    if (this.state.hasError) {
      const label = this.props.section || 'esta sección'
      return (
        <Box
          sx={{
            width: '100%',
            maxWidth: 480,
            margin: '40px auto',
            padding: '24px',
            textAlign: 'center',
            fontFamily: 'Montserrat, sans-serif',
          }}
        >
          <Typography variant='h6' sx={{ mb: 1, fontWeight: 700 }}>
            Algo salió mal en {label}
          </Typography>
          <Typography variant='body2' sx={{ mb: 2, color: '#666' }}>
            El resto de la tienda sigue disponible. Puedes reintentar o volver atrás.
          </Typography>
          {process.env.NODE_ENV !== 'production' && this.state.errorMessage ? (
            <Typography variant='caption' component='pre' sx={{ mb: 2, textAlign: 'left', whiteSpace: 'pre-wrap' }}>
              {this.state.errorMessage}
            </Typography>
          ) : null}
          <Button variant='contained' color='success' onClick={this.handleRetry}>
            Reintentar
          </Button>
        </Box>
      )
    }

    return this.props.children
  }
}

export default SectionErrorBoundary
